module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Deviation Type"},"no":{"title":"Avvikstype"}}')
  delete Component.options._Ctor
}
